import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';
import { MinimalLayout } from 'layout/MinimalLayout';

// render pages
const Imprint = Loadable(lazy(() => import('pages/static/Impressum')));
const Privacy = Loadable(lazy(() => import('pages/static/Privacy')));

// ==============================|| STATIC ROUTING ||============================== //
const StaticRoutes: RouteObject = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: 'privacy',
            element: <Privacy />,
        },
        {
            path: 'imprint',
            element: <Imprint />,
        },
    ],
};

export default StaticRoutes;
